module.exports = __webpack_public_path__ + "assets/img/farm_monitor3.e794ace3.png";